import React from 'react';
import { Typography } from 'ui-v2/components/Typography';
import dayjs from 'dayjs';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import Icon from 'ui-v2/components/Icon/Icon';
import Time from 'core-lib/utils/Time';
import cn from 'classnames';
import s from './ProductReview.module.scss';
import { ProductReview as ProductReviewType } from '../../types/review';

type productReviewPropType = {
  data: ProductReviewType;
  showBorder?: boolean;
  onImageClick?: (item: string) => void;
};
export const ProductReview = ({
  data,
  showBorder = true,
  onImageClick,
}: productReviewPropType) => {
  const now = dayjs();
  const differenceInMilliseconds = now.diff(data?.postedOn) / 1000;
  const { days, minutes, hours } = Time.getTimeFromSeconds(
    differenceInMilliseconds
  );

  function getPostedText() {
    if (days) {
      if (days > 30) {
        let month = Math.floor(days / 30);
        return `${month} ${month > 1 ? 'months' : 'month'} ago`;
      }
      return `${days}d ago`;
    }
    if (hours) return `${hours}h ago`;
    return `${minutes}m ago`;
  }

  return (
    <div className={cn(s.root, { [s.border]: showBorder })}>
      <div className={s.top}>
        <div>
          <Typography
            label={data?.userMeta?.name}
            variant="label_3_bold"
            style={{
              marginBottom: '4px',
            }}
          />
          <div className={s.text}>
            <Typography
              label={`Rated`}
              variant="label_3_regular"
              color="secondary"
            />
            &nbsp;
            <Typography
              label={data?.rating}
              variant="label_3_regular"
              color="secondary"
            />
            &nbsp;
            <div className={s.stars}>
              {Array.from({ length: data?.rating }, (_, i) => (
                <Icon name="StarBold" key={i} color="positive" width={12} height={12} />
              ))}
            </div>
          </div>
        </div>

        <Typography
          label={getPostedText()}
          variant="body_3_regular"
          color="secondary"
        />
      </div>
      {data?.media && (
        <div className={s.imageContainer}>
          {data?.media?.map((item) => (
            <div
              key={item}
              onClick={() => {
                if (onImageClick) onImageClick(item);
              }}
            >
              <ShimmerImage src={item} className={s.image} />
            </div>
          ))}
        </div>
      )}
      <Typography
        label={data?.description}
        variant="body_3_regular"
        color="secondary"
      />
    </div>
  );
};
